import React, {useEffect, useMemo, useState} from "react";
import {useAppSelector} from "../../hooks";
import {CartOrder} from "../../interfaces/CartProduct";
import {useTranslation} from "react-i18next";
import {calculateTotalPrice} from "../../utils/calculateTotalPrice";

const ProductCountSum: React.FC<{ price: number; id: number }> = ({ id }) => {
    const cart = useAppSelector<CartOrder[]>(state => state.cart.value);
    const activeOrder = useAppSelector<number>(state => state.activeOrder.value);
    const currUser = useAppSelector(state => state.user.value);
    const { t } = useTranslation();

    const { totalPrice, hasBoxPrice } = useMemo(() => {
        if (!cart.length || !cart[activeOrder]) {
            return { totalPrice: 0, hasBoxPrice: false };
        }

        const item = cart[activeOrder].orderItems.find(
            item => item.product.id === id
        );

        if (!item) {
            return { totalPrice: 0, hasBoxPrice: false };
        }

        const { quantityPerBox, pricePerBox, price } = item.product;
        const count = item.count;

        const totalPrice = calculateTotalPrice({
            count,
            price,
            quantityPerBox,
            pricePerBox,
        });

        const hasBoxPrice =
            Boolean(quantityPerBox) &&
            Boolean(pricePerBox) &&
            Math.floor(count / quantityPerBox) > 0;

        return { totalPrice, hasBoxPrice };
    }, [cart, activeOrder, id]);

    return (
        <span
            className={`price ${hasBoxPrice ? 'price-quantityPerBox' : ''}`}
            title={
                hasBoxPrice
                    ? String(t('order.priceWithBox'))
                    : ''
            }
        >
      {totalPrice.toFixed(2)} {t(currUser.currency)}
    </span>
    );
};

export default ProductCountSum;
